// Función ECO - Compartir nativo
export const shareAudio = async (audio, baseUrl) => {
  const audioUrl = `${baseUrl}/audio/${audio.audio_id}`;
  const shareText = `Me he acordado de ti con esto 🤗😅 ${audioUrl}`;
  
  // Usar Web Share API si está disponible (móviles)
  if (navigator.share) {
    try {
      await navigator.share({
        text: shareText
      });
      return { success: true, method: 'native' };
    } catch (err) {
      // Usuario canceló o error
      if (err.name !== 'AbortError') {
        console.error('Share error:', err);
      }
      return { success: false, method: 'native' };
    }
  }
  
  // Fallback: copiar al portapapeles
  try {
    await navigator.clipboard.writeText(shareText);
    return { success: true, method: 'clipboard' };
  } catch (err) {
    console.error('Clipboard error:', err);
    return { success: false, method: 'clipboard' };
  }
};

export default shareAudio;
